import React from 'react'
import { PhysicsSurvivalRunner } from '../components/game'
import { useNavigate } from 'react-router-dom'
import { Home } from 'lucide-react'

/**
 * Page test riêng để chạy game độc lập
 * URL: /test-game
 */
const TestGame: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black relative">
      {/* Header test - Đặt bên trái không chồng */}
      <div className="absolute top-12 left-2 z-[100] flex flex-col gap-2">
        <button
          onClick={() => navigate('/')}
          className="bg-purple-600/90 hover:bg-purple-700 text-white px-3 py-1.5 rounded-lg flex items-center gap-2 backdrop-blur-sm transition-all text-sm shadow-lg"
        >
          <Home size={16} />
          <span className="hidden md:inline">Home</span>
        </button>
        <button
          onClick={() => window.location.reload()}
          className="bg-purple-600/90 hover:bg-purple-700 text-white px-3 py-1.5 rounded-lg backdrop-blur-sm transition-all text-sm shadow-lg"
        >
          🔄 <span className="hidden md:inline">Reload</span>
        </button>
      </div>

      {/* Info panel - Đặt bên phải không chồng */}
      <div className="absolute top-12 right-2 z-[100] bg-purple-600/90 backdrop-blur-sm text-white px-3 py-1.5 rounded-lg text-xs shadow-lg">
        <p>🧪 Test: Bài 5 L11</p>
      </div>

      {/* Game */}
      <PhysicsSurvivalRunner
        lop={11}
        chuong={2}
        bai={5}
        minQuestions={10}
        maxQuestions={10}
        onExit={() => {
          console.log('Game exit called')
          navigate('/')
        }}
      />
    </div>
  )
}

export default TestGame

